<template>
  <div>
    <div class="message-container option-content">
      <div class="message-scroll">
        <div class="message-detail" id="containerCheckName">
          <div class="message-box" :key="key" v-for="(item, key) in checkStudentList">
              <v-col>
                <div class="content px-1 py-1">
                  <v-row class="px-3" align="center">
                    <v-col cols="6" class="pl-5">
                      <v-col class="pa-0 title font-weight-black"><label class="txtHead">#ครั้งที่ {{item.term}}</label></v-col>
                      <v-col class="pa-0 body-2 font-weight-light">เมื่อเวลา {{timeToString(item.created_at)}}</v-col>
                    </v-col>
                    <v-col cols="6" class="pt-4 pr-5">
                      <div class="px-1 py-1 text-right">
                        <v-col
                          class="pa-0 subtitle-1 font-weight-bold py-0"
                        ><label class="txtHead">การตอบรับ</label></v-col>
                        <v-col class="pa-0 headline font-weight-black py-0">{{item.count}}</v-col>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
          </div>
        </div>
        <v-row class="px-6">
          <v-col :cols="12">
            <v-btn             
              large
              dark
              elevation="0"
              @click="confirmDialog = true"
              class="title btnNewCheck"
            >
              <v-icon left>mdi-plus</v-icon>
              New Check
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="px-6">
          <v-col :cols="12" class="pt-0">
            <v-btn
              large
              @click="initialize"
              class="title btnReload"
              elevation="0"
            >
              <v-icon left>mdi-cached</v-icon>
              {{$vuetify.lang.t("$vuetify.courseManagement.filterBar.refresh")}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- <v-dialog v-model="confirmDialog" max-width="350">
      <v-card class="pt-10">
        <v-card-text>คุณต้องการเช็คชื่อผู้เรียนที่กำลังรับชมการถ่ายทอดสดอยู่ใช่หรือไม่ ?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="confirmDialog = false"
          >{{$vuetify.lang.t('$vuetify.cancel')}}</v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="requestCheckStudent"
          >{{$vuetify.lang.t('$vuetify.confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="confirmDialog" max-width="450">
        <v-card>
          <v-card-title class="headline">เวลาในการเช็คชื่อ</v-card-title>

          <v-card-text class="pb-0">
            <v-row>
              <v-col>
                <p
                  class="subtitle-1"
                >เมื่อกดยืนยันแล้ว ผู้ชมถ่ายทอดสดจะสามารถเช็คชื่อได้ในเวลาที่กำหนดเท่านั้น</p>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col class="d-flex pa-0" cols="6">
                <v-text-field
                  hide-details
                  class="mx-3"
                  type="number"
                  v-model="mins"
                  min="0"
                  @change="checkMinMins"
                  single-line
                  outlined
                ></v-text-field>
                <!-- <v-spacer></v-spacer> -->
                <p class="subtitle-1 pt-3">นาที</p>
              </v-col>
              <v-col class="d-flex pa-0" cols="6">
                <v-text-field
                  hide-details
                  class="mx-3"
                  type="number"
                  v-model="secs"
                  min="0"
                  max="59"
                  @change="checkMinSecs"
                  single-line
                  outlined
                ></v-text-field>
                <!-- <v-spacer></v-spacer> -->
                <p class="subtitle-1 pt-3">วินาที</p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mt-3"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="title"
              color="grey darken-1"
              large
              outlined
              @click="confirmDialog = false"
            >ยกเลิก</v-btn>

            <v-btn class="title" color="primary darken-1" large dark @click="requestCheckStudent">ยืนยัน</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
import { getCheckStudentList, requestCheckStudent } from "@/service/course/live";
import $ from "jquery";
export default {
  props:{
    liveId:{
      type: String
    }
  },
  name: "checkName",
  data: () => ({
    // views
    confirmDialog: false,

    // params
    // liveStreamID: "5ebd1312fa34d74e7c11344e",
    // delay: 10000,
    mins: 0,
    secs: 0,

    // data
    checkStudentList: []
  }),
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.checkStudentList = []
      this.mins= 0,
      this.secs= 30,
      await this.getCheckStudentList();
    },
    checkMinMins() {
      if (this.mins < 0){
       this.mins = 0;
      }
      else if (this.mins >= 60){
        this.mins = 59;
      }
      this.mins = Math.floor(this.mins)
    },
    checkMinSecs() {
      if (this.secs < 0){
        this.secs = 0;
      }
      else if (this.secs >= 60){
        this.secs = 59;
      }
      this.secs = Math.floor(this.secs)
    },
    async requestCheckStudent() {
      let params = {
        idlivestream: this.liveId,
        delay: (this.mins * 60 * 1000) + (this.secs * 1000)
      };
      this.confirmDialog = false;

      await requestCheckStudent(params);
      await this.initialize();
    },
    timeToString(time) {
      var date = new Date(time);
      var hours = date.getHours();
      var minutes = "0" + date.getMinutes();

      return hours + ':' + minutes.substr(-2) + " น.";
    },
    async getCheckStudentList() {
      let params = {
        idlivestream: this.liveId
      };

      this.checkStudentList = await getCheckStudentList(params);
      
      // setTimeout(function() {
      //   $("#containerCheckName").scrollTop($("#containerCheckName")[0].scrollHeight);
      // }, 100);
    }
  }
};
</script>
<style lang="scss" scoped>
.txtHead {
  color: #00527B,
}
.btnNewCheck{
  background-color: #50adde !important;
  border-radius: 0px;
  width: 100%;
  text-transform: unset;
}
.btnReload{
  background-color: #EAE9E9 !important;
  border-radius: 0px;
  width: 100%;
  text-transform: unset;
  
}
.message-container {
  position: relative;
  // padding: 12px;
  height: 88vh;
  background-color: white;
}
.message-scroll {
 height: 87vh;
 overflow: hidden;
}
.message-detail {
  /* background-color: ghostwhite; */
  height: 80%;
  /* margin-bottom: 10px; */
  overflow-y: scroll;
  /* overflow: hidden; */
}
.message-detail:hover {
  /* background-color: ghostwhite; */
  /* height: 470px; */
  /* margin-bottom: 10px; */
  /* overflow-y: scroll; */
  /* overflow: hidden; */
}
.chat-avatar {
  padding: 10px;
  width: 50px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.chat-name {
  font-weight: bold;
}
.chat-time {
  font-weight: bold;
  padding: 10px;
  width: 80px;
  float: right;
}
.owner-message {
  color: white;
}
/* .send-message-container{

} */
// .send-message-container {
//   /* position: relative; */
//   /* height: 200px; */
//   /* border: 3px solid red; */
//   /* position: absolute; */
//   /* width: 100%; */
//   /* bottom: 10px; */
//   position: absolute;
//   bottom: 10px;
//   width: 92%;
// }

.send-message-input {
  /* position: absolute;
  bottom: 10px; */
  /* border: 3px solid #8AC007; */
  display: inline-block;
}
.send-message-btn {
  float: right;
  /* display: inline-block; */
  width: 90px;
}
.message-box {
  padding-left: 15px;
  padding-right: 15px;
  // margin-bottom: 15px;
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 8px;
}
.send-container {
  padding-left: 10px;
  padding-right: 10px;
}
.content {
  background-color: #efefef;
}

</style>